/*eslint-disable*/
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Stack, Divider, Typography, Card, IconButton, Tooltip } from '@mui/material';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

// hooks
import { useResponsive } from 'src/hooks/use-responsive';
import { fLocalFullDateTime } from 'src/utils/format-time';

// components
import Iconify from 'src/components/iconify';
import { RealTimeButton } from 'src/components/custom-real-time-button';
import useMediaQuery from '@mui/material/useMediaQuery';

// ----------------------------------------------------------------------

export default function AppDateTimePickerWidget({
  label,
  initialDateTime,
  setDateTime,
  hasRealTimeButton,
  realTimeState,
  setRealTimeState,
  // setNeedUpdate,
  triggerRefresh,
  updateShipmentList,
  ...other
}) {
  const theme = useTheme();
  const [selectedDate, setSelectedDate] = useState(initialDateTime);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleOnOpen = () => {
    // Set the open prop of the MobileDateTimePicker component to true
    setIsOpen(true);
    if (hasRealTimeButton) {
      setRealTimeState(false);
    }
  };

  useEffect(() => {
    setSelectedDate(initialDateTime)
  }, [initialDateTime])

  const handleOnClose = () => {
    setIsOpen(false);
  };

  const handleOnDateChange = (date) => {
    updateShipmentList(false, [])
    setDateTime(new Date(date));
    setSelectedDate(new Date(date));
    if (hasRealTimeButton) {
      setRealTimeState(false);
    }
    const today = new Date();
    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      setOpenTooltip(true);
    }
    // setNeedUpdate(true)
    triggerRefresh?.();
    handleOnClose();
  };

  const handleMouseEnter = () => {
    setOpenTooltip(true);
  };

  const handleMouseLeave = () => {
    setOpenTooltip(false);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setOpenTooltip(false);
    }, 7000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [openTooltip]);

  const smUp = useResponsive('up', 'sm');

  // useEffect(() => {
  //   if (!hasRealTimeButton) {
  //     return;
  //   }
  //   const intervalId = setInterval(() => {
  //     if (realTimeState) {
  //       setDateTime(new Date());
  //       setNeedUpdate(true)
  //     } else {
  //       clearInterval(intervalId);
  //     }
  //   }, 60000);
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [realTimeState]);

  return (
    <Card {...other} sx={{width:'100%'}}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        divider={
          <Divider
            orientation={smUp ? 'vertical' : 'horizontal'}
            flexItem
            sx={{ borderStyle: 'dashed' }}
          />
        }
      >
        <Stack
          direction="row"
          spacing={3}
          flexGrow={1}
          justifyContent="left"
          alignItems={{ xs: 'center', md: 'flex-start' }}
          sx={{
            p: {
              xs: theme.spacing(5, 3, 0, 3),
              md: theme.spacing(5),
              sm: theme.spacing(4)
            },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <div>
            <Typography variant="h4" sx={{ mb: 0.5 }}>
              {fLocalFullDateTime(selectedDate)}
            </Typography>

            <Typography variant="body2" sx={{ opacity: 0.72 }}>
              {label}
            </Typography>
          </div>
        </Stack>

        <Stack
          direction="row"
          spacing={3}
          flexGrow={1}
          justifyContent={{ xs: "center", md: 'right' }}
          alignItems={{ xs: 'center', md: 'center' }}
          sx={{
            p: {
              xs: theme.spacing(5, 3, 1, 3),
              md: theme.spacing(5),
              sm: theme.spacing(3)
            },
            textAlign: { xs: 'center', md: 'right' },
          }}
        >
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Tooltip
              title={realTimeState ? "Desativar relatório em tempo real" : "Ativar relatório em tempo real"}
              placement="top"
              open={openTooltip}
              enterDelay={1000}
              arrow
              >
              <RealTimeButton
                realTimeState={realTimeState}
                hasRealTimeButton={hasRealTimeButton}
                setRealTimeState={setRealTimeState}
                triggerRefresh={triggerRefresh}
              />
            </Tooltip>
          </div>
          <IconButton
            size="medium"
            color="primary"
            onClick={handleOnOpen}
            sx={{
              width: 40,
              height: 40,
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
              boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.33)',
            }}
          >
            <Iconify icon="solar:pen-bold" />
          </IconButton>

          <MobileDateTimePicker
            className="mobile-datetime-picker"
            sx={{ display: 'none' }}
            disableFuture
            open={isOpen}
            value={selectedDate}
            onClose={handleOnClose}
            onAccept={handleOnDateChange}
          />
        </Stack>
      </Stack>
    </Card>
  );
}

AppDateTimePickerWidget.propTypes = {
  label: PropTypes.string,
  initialDateTime: PropTypes.instanceOf(Date),
  setDateTime: PropTypes.func,
  hasRealTimeButton: PropTypes.bool,
  realTimeState: PropTypes.bool,
  setRealTimeState: PropTypes.func,
  // setNeedUpdate: PropTypes.func,
  triggerRefresh: PropTypes.func,
  updateShipmentList: PropTypes.func,
};
